var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDemoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 89,
    viewBox: "0 0 94 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.25 72.7071C47.75 82.3607 39.4166 88.4705 30.1666 88.4705C13.5 88.4705 0 68.6746 0 44.2353C0 19.7959 13.5 0 30.1666 0C39.4166 0 47.75 6.10984 53.25 15.7634C47.5833 22.4842 44 32.7488 44 44.2353C44 55.7218 47.5833 66.1085 53.25 72.7071Z",
    fill: "#004CC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94 44.2352C94 64.5199 82.8333 80.8943 69 80.8943C63.0833 80.8943 57.5833 77.8394 53.25 72.7071C57.6667 65.0087 60.3333 55.1108 60.3333 44.2352C60.3333 33.3597 57.6667 23.4618 53.25 15.7634C57.5833 10.6311 63 7.57617 69 7.57617C82.8333 7.57617 94 24.0727 94 44.2352Z",
    fill: "#009FE3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoLogo);
export default __webpack_public_path__ + "static/media/demo_logo.7e3e5d4b9457fbfaa4ef32d567bf9390.svg";
export { ForwardRef as ReactComponent };